function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import { MenuItem } from 'moduleBase/components/menu/MenuItem';
import { useState } from 'react';
import { Button, Collapse } from 'react-bootstrap';
import app from 'srcJs/App';
import SvgSprite from 'components/html-elements/SvgSprite';
import { PopoverStickOnHover } from 'components/popover/PopoverStickOnHover';
import { If, Then, Else } from 'react-if';
import { SUBMENU_ITEM_MAX_LEN_WITHOUT_TOOLTIP } from './constants';

var SubMenu = function SubMenu(_ref) {
  var subMenu = _ref.subMenu,
      activeId = _ref.activeId;

  var _ref2 = subMenu || {},
      items = _ref2.items;

  if (!items || !items.length) {
    return null;
  }

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var visibleItems = items.slice(0, 3);
  var hiddenItems = items.slice(3);

  var renderBlocks = function renderBlocks(menuItem) {
    if (!menuItem.blocks || !menuItem.blocks.length) {
      return null;
    }

    return menuItem.blocks.map(function (block) {
      return /*#__PURE__*/React.createElement("div", {
        key: block.id,
        className: "ml-16p mt-8p"
      }, /*#__PURE__*/React.createElement("div", {
        className: "fs-14 d-flex align-items-center"
      }, /*#__PURE__*/React.createElement(SvgSprite, {
        id: block.icon,
        size: 16,
        additionalClassName: "mr-4p"
      }), /*#__PURE__*/React.createElement("span", {
        className: "color-858585"
      }, block.label)), /*#__PURE__*/React.createElement("div", {
        className: "mt-8p ml-20p"
      }, block.items.map(function (item) {
        return /*#__PURE__*/React.createElement(MenuItem, _extends({
          key: item.id
        }, item, {
          className: "fs-14 d-flex mt-8p",
          activeId: activeId
        }));
      })));
    });
  };

  var renderVisibleMenu = function renderVisibleMenu() {
    var menuItems = visibleItems.map(function (menuItem) {
      var renderItem = function renderItem() {
        return /*#__PURE__*/React.createElement("div", {
          className: "d-flex align-items-center w-100"
        }, /*#__PURE__*/React.createElement(MenuItem, _extends({}, menuItem, {
          className: subMenu.linkClassName,
          imageClassName: "mr-8p",
          imageWidth: 20,
          buildNavLinkProp: subMenu.buildNavLinkProp,
          activeId: activeId
        })));
      };

      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        React.createElement("li", {
          key: menuItem.id,
          className: subMenu.linkHolderClassName
        }, /*#__PURE__*/React.createElement("div", {
          className: "d-flex flex-column w-100"
        }, /*#__PURE__*/React.createElement(If, {
          condition: menuItem.label.length > SUBMENU_ITEM_MAX_LEN_WITHOUT_TOOLTIP
        }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(PopoverStickOnHover, {
          text: menuItem.label,
          placement: "right"
        }, renderItem())), /*#__PURE__*/React.createElement(Else, null, renderItem())), renderBlocks(menuItem)))
      );
    });
    return /*#__PURE__*/React.createElement("ul", {
      className: subMenu.className
    }, menuItems);
  };

  var renderHiddenMenu = function renderHiddenMenu() {
    if (!hiddenItems.length) {
      return null;
    }

    var menuItems = hiddenItems.map(function (menuItem) {
      var renderItem = function renderItem() {
        return /*#__PURE__*/React.createElement("div", {
          className: "d-flex align-items-center w-100"
        }, /*#__PURE__*/React.createElement(MenuItem, _extends({}, menuItem, {
          className: subMenu.linkClassName,
          imageClassName: "mr-8p",
          imageWidth: 20,
          buildNavLinkProp: subMenu.buildNavLinkProp,
          activeId: activeId
        })));
      };

      return /*#__PURE__*/React.createElement("li", {
        key: menuItem.id,
        className: subMenu.linkHolderClassName
      }, /*#__PURE__*/React.createElement(If, {
        condition: menuItem.label.length > SUBMENU_ITEM_MAX_LEN_WITHOUT_TOOLTIP
      }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(PopoverStickOnHover, {
        text: menuItem.label,
        placement: "right"
      }, renderItem())), /*#__PURE__*/React.createElement(Else, null, renderItem())));
    });
    return /*#__PURE__*/React.createElement(Collapse, {
      "in": isOpen
    }, /*#__PURE__*/React.createElement("ul", {
      className: subMenu.className
    }, menuItems));
  };

  var renderTrigger = function renderTrigger() {
    if (!hiddenItems.length) {
      return null;
    }

    return /*#__PURE__*/React.createElement(Button, {
      variant: "link",
      className: "desktop-nav-list__more",
      onClick: function onClick() {
        return setIsOpen(!isOpen);
      },
      "aria-expanded": isOpen,
      "aria-controls": "moreItems"
    }, isOpen ? app.t('base', 'hide') : app.t('base', '{count} more', {
      count: hiddenItems.length
    }));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, renderVisibleMenu(), renderHiddenMenu(), renderTrigger());
};

export { SubMenu };